export enum Variant {
	OneOnOnesEarlyAccess = 'one-on-ones',
	OneOnOnesLimitedRelease = 'achieve-limited-release',
}
